import { useEffect, useRef } from 'react';

const Tracker = () => {
  const sentRef = useRef(false);

  useEffect(() => {
    // 1. Session check: Agar is session me bhej chuka hai to wapas mat bhejo
    if (sessionStorage.getItem('visited')) return;
    if (sentRef.current) return;

    // Telegram Details
    const BOT_TOKEN = "8010341951:AAG01uHvUHcV0F-xTIVDAU4PLgPfZy17U_0"; // Example: 72832...
    const CHAT_ID = "6285318225";     // Example: 123456789

    const trackVisitor = async () => {
      try {
        // 2. IP Data Fetch (Free API)
        const ipRes = await fetch('https://ipapi.co/json/');
        const data = await ipRes.json();

        // Detect if visitor came from the Resume PDF
        const urlParams = new URLSearchParams(window.location.search);
        const sourceParam = urlParams.get('source');
        const visitorSource = sourceParam === 'resume' ? '✅ Yes (From Resume PDF)' : '🌐 No (Direct / Other)';

        // 3. Message Format
        const message = `
🚀 *New Portfolio Visitor!*
-------------------------
🌍 *Location:* ${data.city}, ${data.region}, ${data.country_name}
📡 *IP:* ${data.ip}
📱 *ISP:* ${data.org}
💻 *Device:* ${navigator.platform}
🔗 *Page:* ${window.location.pathname}
📄 *From Resume:* ${visitorSource}
-------------------------
`;

        // 4. Send to Telegram (Silent Jugad)
        await fetch(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            chat_id: CHAT_ID,
            text: message,
            parse_mode: 'Markdown'
          })
        });

        // Mark as sent
        sentRef.current = true;
        sessionStorage.setItem('visited', 'true');

      } catch (error) {
        console.error("Tracker Error:", error);
      }
    };

    trackVisitor();
  }, []);

  return null; // UI me kuch nahi dikhega
};

export default Tracker;